import type { ReactNode } from 'react';

export const symbol_format_image_break_left: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M150-120q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h660q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H150Zm-30-195v-330q0-12.75 8.63-21.38Q137.25-675 150-675h330q12.75 0 21.38 8.62Q510-657.75 510-645v330q0 12.75-8.62 21.37Q492.75-285 480-285H150q-12.75 0-21.37-8.63Q120-302.25 120-315Zm60-30h270v-270H180v270Zm-30-435q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h660q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H150Zm165 300Z"
		/>
	</svg>
);
